import { Deserializable } from '../../protocols/deserializable';
import { Address } from './address';

export class MemberDeathRecordLegalRepresentative implements Deserializable {
  public id!: number;
  public deathRecordId!: number;
  public lawFirm!: string;
  public contactFirstName!: string;
  public contactLastName!: string;
  public email!: string;
  public phoneNumberCountryCode!: string;
  public phoneNumber!: string;
  public address!: Address;

  public onDeserialize(): void {
    this.address = window.injector.Deserialize.instanceOf(Address, this.address);
  }
}
